<div [formGroup]="filterGroup" class="feed" id="feed">

    <div [class.filtered]="filterFormValue.sortBy || filterFormValue.search?.length || filterFormValue.isPinned != null || filterGroup.value['filterBy']"
         class="filtersRow">
        <mat-form-field appearance="fill" class="noBottomPadding searchFrom" color="accent">
            <mat-label>Search discussions and polls</mat-label>
            <input (keyup)="searchKeyup()" (keydown)="searchKeydown()" (keyup.enter)="applyFilters()"
                   formControlName="search" matInput type="text"/>
            <button type="button" (click)="applyFilters()" aria-label="Search discussions and polls" mat-icon-button matPrefix>
                <mat-icon color="accent">search</mat-icon>
            </button>
            @if (filterFormValue.search?.length) {
                <button (click)="clearSearch(); applyFilters()" aria-label="Clear"
                        mat-icon-button
                        matSuffix>
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>
        <mat-form-field class="datePicker noBottomPadding dateRange" color="accent">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input (dateChange)="applyFilters()" formControlName="startDate" matStartDate placeholder="Start date">
                <input (dateChange)="applyFilters()" formControlName="endDate" matEndDate placeholder="End date">
            </mat-date-range-input>
            @if (dateSet) {
                <mat-datepicker-toggle (click)="clearDate()" matIconSuffix>
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
            }
            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
            <mat-date-range-picker #picker color="accent"></mat-date-range-picker>

            @if (filterGroup.controls['startDate'].hasError('matStartDateInvalid')) {
                <mat-error>Invalid start date
                </mat-error>
            }
            @if (filterGroup.controls['endDate'].hasError('matEndDateInvalid')) {
                <mat-error>Invalid end date
                </mat-error>
            }
        </mat-form-field>
        <div class="sortBtn">

            <button [appCustomButtonColours]="community?.sort_by_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="sortfilters" aria-label="Sort by" color="accent"
                    mat-mini-fab
                    matTooltip="Sort by">
                <mat-icon>sort</mat-icon>
            </button>
            <mat-menu #sortfilters="matMenu">
                @for (option of sortOptions; track option) {
                    <button (click)="setFilters(option.value, 'sortBy')"
                            [ngClass]="{'selectedBtn' : filterGroup.value['sortBy'] == option.value }"
                            mat-menu-item>{{ option.label }}
                    </button>
                }
            </mat-menu>
        </div>
        <div class="filterBtn">
            <button [appCustomButtonColours]="community?.filter_by_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="filters" aria-label="Filter By" color="accent"
                    mat-mini-fab
                    matTooltip="Filter by">
                <mat-icon>filter_list</mat-icon>
            </button>
            <mat-menu #filters="matMenu">
                @for (option of filterOptions; track option) {
                    <button (click)="setFilters(option.value, 'filterBy')"
                            [ngClass]="{'selectedBtn' : filterGroup.value['filterBy'] == option.value }"
                            mat-menu-item>{{ option.label }}
                    </button>
                }
            </mat-menu>
        </div>
        <div class="pinnedFilter">
            <button [appCustomButtonColours]="community?.filter_pinned_button_color_hex || 'var(--accent)'"
                    [matMenuTriggerFor]="pinnedFilter" aria-label="Filter pinned" color="accent"
                    mat-mini-fab
                    matTooltip="Filter pinned">
                <mat-icon svgIcon="thumbtackIcon"></mat-icon>
            </button>
        </div>
        @if (filterFormValue.sortBy || filterFormValue.search?.length || filterFormValue.isPinned != null || filterGroup.value['filterBy']) {
            <div class="clearFilters">
                <button (click)="location.reload()"
                        [appCustomButtonColours]="community?.clear_filters_button_color_hex || 'var(--accent)'"
                        aria-label="Clear Filters" color="accent"
                        mat-mini-fab
                        matTooltip="Clear filters">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }
        <mat-menu #pinnedFilter="matMenu">
            @for (option of showPinnedOptions; track option) {
                <button (click)="setFilters(option.value, 'isPinned')"
                        [ngClass]="{'selectedBtn' : filterGroup.value['isPinned'] === option.value }"
                        mat-menu-item>{{ option.label }}
                </button>
            }
        </mat-menu>
    </div>
    @if (isMobile) {
        <mat-form-field class="fullRowGrid categoryPicker w-100" appearance="outline">
            <mat-label>Browse categories</mat-label>
            <mat-select [canSelectNullableOptions]="true" [value]="filterGroup.value.isClosedLoop ? -1 : filterGroup.value.category"
                        (selectionChange)="applyFilters($event.value)">
                @for (option of categoryOptions; track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    } @else {
    <app-tab-selector (tabChange)="applyFilters($event)" [defaultValue]="setCategory" [options]="categoryOptions"
                      class="fullRowGrid"
                      formControlName="category"></app-tab-selector>
    }
    @if (isMobile && !this.filterGroup.value.search) {
        <div class="gap-10 flex-col pinnedPosts mt-10">
            @for (post of sidebarPosts; track trackByPostId($index, post)) {
                <app-post-card
                        (action)="loadPostFromSidebar(currentCommunityId)"
                        [hidePoll]="true"
                        [post]="post"
                        [reducedContent]="true"
                        [showPinnedBadge]="false"
                ></app-post-card>
            }
        </div>
    }
    <div infiniteScroll
         [infiniteScrollDistance]="1"
         [infiniteScrollThrottle]="50"
         (scrolled)="triggerInfiniteScroll()">
        @if (content?.length) {
            @for (post of content; track trackByPostId($index, post)) {
                <app-post-card
                    #postCard
                    (action)="reloadContent()"
                    (scrollFinished)="isRequiredScrollToPost(post.id) && postCard.startBlinkAnimation()"
                    [appScrollIntoView]="isRequiredScrollToPost(post.id)"
                    [post]="post"
                    [showPinnedBadge]="true"
                    class="d-block my-10"
                ></app-post-card>
            }
        } @else {
            @if (loading == false) {
                <mat-card class="my-10">
                    <mat-card-content class="d-flex align-items-center justify-content-center">
                        @if (!filtersApplied) {
                            <div class="p-20">
                                There are no posts in this community yet
                            </div>
                        }
                        @if (filtersApplied) {
                            <div class="p-20">
                                There are no posts matching your selected filters
                            </div>
                        }
                    </mat-card-content>
                </mat-card>
            }
        }
        @if (loading) {
            <div class="w-100 d-flex justify-content-center">
                <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
            </div>
        }
    </div>
</div>

